import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
}

export const SEOHead = ({ title, description }: SEOHeadProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};
